import { useWebviewContext } from '../webview'

import {
  cmsGetStoryblokUniversalLinkProps,
  type CmsStoryblokLinkProps,
} from './cmsStoryblokLinkProps'
import { type StoryblokMultilink } from './storyblok'

/**
 * Returns the appropriate target and URL for a Storyblok link, depending on the webview context.
 *
 * If the page is running inside an app webview and the `appLink` is provided, it will use the `appLink`.
 * Otherwise, it will use the provided `link`.
 *
 * The function uses `useWebviewContext` to determine if the app is running inside a webview.
 * This is useful for handling navigation differently between web and app environments.
 *
 * @param appLink - Optional Storyblok link to use when in a webview context.
 * @param link - The default Storyblok link to use.
 * @returns An object containing the link target (`'_blank'`, `'_self'`, or `undefined`) and the resolved URL.
 */
export const useStoryblokWebOrAppLink = ({
  appLink,
  link,
}: {
  appLink?: StoryblokMultilink
  link: StoryblokMultilink
}): CmsStoryblokLinkProps | undefined =>
  cmsGetStoryblokUniversalLinkProps(
    {
      appLink,
      webLink: link,
    },
    {
      webview: useWebviewContext(),
    },
  )
